<script>
export default {
  name: 'has-pagination',
  data () {
    return {
      currentPage: 1,
      paginationMetaData: null,
      orderColumn: 'name',
      orderDirection: 'ASC'
    };
  },
  mounted () {
    this.loadOrderSettingsFromLocalStorage(this.$options.name);
    this.$bus.on('pagination-page-changed', this.setPage);
    this.$bus.on('pagination-reset', this.resetPagination);
    this.$bus.on('table-ordering-change', this.orderingChange);
  },
  methods: {
    setPage (page) {
      this.currentPage = page;
      this.debouncedLoadFilteredData();
    },
    resetPagination () {
      this.currentPage = 1;
      this.debouncedLoadFilteredData();
    },
    loadOrderSettingsFromLocalStorage (viewName) {
      if (viewName === 'product-types') {
        this.orderDirection = 'ASC';
        return;
      }

      if (window.localStorage.getItem('crm-ordering-' + viewName + '-column')) {
        this.orderColumn = window.localStorage.getItem('crm-ordering-' + viewName + '-column').replace(/[^a-z0-9_\-]/gmi, '');
      }

      if (window.localStorage.getItem('crm-ordering-' + viewName + '-direction')) {
        this.orderDirection = window.localStorage.getItem('crm-ordering-' + viewName + '-direction') === 'DESC' ? 'DESC' : 'ASC';
      }
    },
    orderingChange (payload) {
      this.orderColumn = payload.column;
      this.orderDirection = payload.direction;
      this.debouncedLoadFilteredData();
    }
  },
  beforeUnmount () {
    this.$bus.off('pagination-page-changed', this.setPage);
    this.$bus.off('pagination-reset', this.resetPagination);
    this.$bus.off('table-ordering-change', this.orderingChange);
  }
}
</script>
